import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { protectedRoutes } from 'constants/routes'

import { Button, Container, Grid } from '@mui/material'
import { MessageInfo, SearchBox } from 'components/commonparts'
import ShowLastUpdateDatetime from 'components/commonparts/ShowLastUpdateDatetime/ShowLastUpdateDatetime'
import { DataList } from 'components/parts/CompanyList'
import { useCompany } from 'hooks/useCompany'
import { useGridSearch } from 'hooks/useGridSearch'
import { initDataListStatus } from 'types/types'

import type { CompanyOutput } from 'api-client'
import type { DataListStatus } from 'types/types'

function CompanyList() {
  const navigate = useNavigate()

  const { companySearch, fetchCompanySearch, compnaySearchIsLoading, companySearchResult } = useCompany()
  const gridSearch = useGridSearch({ autoShowOnCtrlF: true })

  const [listStatus, setListStatus] = useState<DataListStatus>({
    ...initDataListStatus(),
  })

  // ソート順とページ番号の変更通知
  const onListStatusChange = (status: DataListStatus) => {
    fetchCompanySearch({
      limit: status.paginationModel.pageSize,
      pageNo: status.paginationModel.page + 1,
    })

    setListStatus({ ...listStatus, sortModel: status.sortModel, paginationModel: status.paginationModel })
  }

  useEffect(() => {
    fetchCompanySearch({
      limit: listStatus.paginationModel.pageSize,
      pageNo: 0,
    })
  }, [])

  return (
    <Container maxWidth="xl">
      <Grid direction="row" container justifyContent="space-between">
        <Grid component="div" marginTop={1} marginBottom={1}>
          <Button variant="contained" onClick={() => navigate(`/${protectedRoutes.CompanyDetail.path}`)}>
            企業を追加
          </Button>
        </Grid>
        <Grid component="div">
          <ShowLastUpdateDatetime<CompanyOutput>
            list={companySearch.list}
            lastUpdateDatetime={companySearch.lastUpdateDatetime}
          />
        </Grid>
      </Grid>
      <SearchBox
        gridRef={gridSearch.searchBoxProps.gridRef}
        findSearchValue={gridSearch.searchBoxProps.findSearchValue}
        setFindSearchValue={gridSearch.searchBoxProps.setFindSearchValue}
        activeMatchNum={gridSearch.searchBoxProps.activeMatchNum}
        onFindChanged={gridSearch.searchBoxProps.onFindChanged}
        isVisible={gridSearch.searchBoxProps.isVisible}
        onHide={gridSearch.searchBoxProps.onHide}
      />
      <DataList
        list={companySearch}
        isLoading={compnaySearchIsLoading}
        listStatus={listStatus}
        onListStatusChange={onListStatusChange}
        gridRef={gridSearch.gridRef}
        findSearchValue={gridSearch.gridSearchProps.findSearchValue}
        onFindChanged={gridSearch.gridSearchProps.onFindChanged}
        isSearchVisible={gridSearch.searchBoxProps.isVisible}
      />
      <Grid direction="row" container justifyContent="space-between">
        <Grid component="div">
          <MessageInfo result={companySearchResult} />
        </Grid>
      </Grid>
    </Container>
  )
}

export default CompanyList
